import React, { useState, useMemo, useEffect, useRef } from 'react'
import { useDispatch, useSelector } from "react-redux";
import { useStationRuleListQuery } from '../../../redux/services/ARFSM.js';
import TableGrid from "../../../Components/common/TableGrid";
import pen from '../../../assets/images/common/pen.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faXmark, faPowerOff } from '@fortawesome/free-solid-svg-icons';
import { ReactComponent as Tick } from "../../../assets/images/icon_svg/tick.svg";
import { ReactComponent as Edit } from "../../../assets/images/icon_svg/pen_w_line.svg";
import { ReactComponent as Plus } from "../../../assets/images/icon_svg/plus.svg";
import { ReactComponent as Poweroff } from "../../../assets/images/icon_svg/poweroff.svg";
import TableFilters from '../../../Components/common/TableGrid/TableFilters.js';
import { CallApi, CommonModal } from '../../../Components/common/CommonFunctions.js';
import { toast } from 'react-toastify';
import { Button } from 'react-bootstrap';
import StationRulesDetails from './StationRulesDetails.js';


const StationRules = () => {

  const isMounted = useRef(false);
  const [station, setStation] = useState([]);
  const [stDetails, setStDetails] = useState(false);
  const [detailsData, setDetailsData] = useState({});
  const { pageDetails, filters, sortby, selectedRows, tab } = useSelector((state) => state.table);

  const [itemsPerPage, setItemsPerPage] = useState(25);
  const [currentPage, setCurrentPage] = useState(1);

  const [pendingActivateRow, setPendingActivateRow] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [modalType, setModalType] = useState(null); 


  const fetchStation = () => {
    CallApi({
      endPoint: 'station-handler-list',
      onSuccess: (res) => {
        const innerData = res.data.response_data;
        setStation(innerData);
        const preActive = {};
        innerData.forEach((row) => {
          if (row.is_active) preActive[row.station_id] = true;
        });
      },
      onError: (msg) => toast.error(msg)
    });
  }

  useEffect(() => {
    if (isMounted.current) return;
    fetchStation();
    isMounted.current = true;
  }, []);


  const handleActivateClick = (row) => {
    setPendingActivateRow(row);
    setModalType('activate');
     setShowModal(true);
  };

  const handleDeactivateClick = () => {
    setModalType('deactivate');
     setShowModal(true);
  };

  const handleModalClose = () => {
  setShowModal(false);
  setTimeout(() => {
    setModalType(null);
    setPendingActivateRow(null);
  }, 200);
  };

  const handleBtnClick = (row) => {
    setDetailsData(row);
    setStDetails(true);
  };

  const handleActivateConfirm = () => {
    CallApi({
      endPoint: 'rfs-monitor-settings/update-status',
      method: 'post',
      payload: {
        port_Id: pendingActivateRow.port_Id,
        code: pendingActivateRow.code,
      },
      onSuccess: () => {
        handleModalClose();
        toast.success(`Station ${pendingActivateRow.code} activated successfully`);
        refetch();
      },
      onError: (msg) => {
        handleModalClose();
        toast.error(msg);
      },
    });
  };

  const handleDeactivateConfirm = () => {
    CallApi({
      endPoint: 'rfs-monitor-settings/update-status',
      method: 'post',
      payload: {
        port_Id: detailsData.port_Id,
        code: detailsData.code,
        status: 'Inactive',
      },
      onSuccess: () => {
        handleModalClose();
        toast.success(`Station ${detailsData.code} deactivated successfully`);
        refetch();
        handleBack();
      },
      onError: (msg) => {
        handleModalClose();
        toast.error(msg);
      },
    });
  };

  const buildFilterParams = (filtersObj) => {
    const params = {};
    Object.entries(filtersObj).forEach(([key, value]) => {
      if (value === undefined || value === null || value === "" || (Array.isArray(value) && value.length === 0)) {
        return;
      }
      if (Array.isArray(value)) {
        params[key] = JSON.stringify(value);
      } else {
        params[key] = value;
      }
    });
    if (Object.keys(params).length > 0) {
      params.is_filter = true;
    }
    return params;
  };

  const queryParams = useMemo(() => {
    const filterParams = buildFilterParams(filters);
    const params = {
      ...filterParams,
      pagenum: pageDetails.pagenum,
      pagesize: pageDetails.pagesize,
    };
    if (sortby?.sortdatafield) {
      params.sortdatafield = sortby.sortdatafield;
      params.sortorder = sortby.sortorder;
    }
    return params;
  }, [filters, pageDetails, sortby]);

  const { data: myData, isFetching, refetch } = useStationRuleListQuery(queryParams, {
    skip: pageDetails.pagesize === 0,
    refetchOnMountOrArgChange: true,
  });

  const filtersConfig = [
    { type: "input", field: "code", placeholder: "Search Station Code" },
  ];

  const columns = [
    { label: 'Station Code', field: 'code', enableSearch: true, cls: "tw-2" },
    {
      label: 'Status', enableSearch: true, cls: "tw-2",
      renderCell: (row) => {
         const isInactive =
          row?.status == null || row?.status === "Inactive";

          return isInactive
            ? <span>Inactive</span>
            : <button className="setting_activebtn"><Tick/> Active</button>;
            }
    },
    {
      label: 'Action', cls: "tw-2",
      renderCell: (row) => {
      const isInactive =
      row?.status == null || row?.status === "Inactive";
      return isInactive
        ? (<button className='setting_graybtn' onClick={() => handleActivateClick(row)}><Plus/> Activate</button>)
        : (<button className="setting_managebtn" onClick={() => handleBtnClick(row)}><Edit/> Manage</button>);
        }
    },
  ];

  const handleBack = () => { setDetailsData({}); setStDetails(false); };
  const ItemPChange = (val) => { setItemsPerPage(val); setCurrentPage(1); };
  const currPChange = (val) => { setCurrentPage(val); };

  return (
    <>
      {stDetails ? (
        <>
          <div>
            <button onClick={handleBack} className='back_set'>
              <FontAwesomeIcon icon={faArrowLeft} /> Back
            </button>
            <div className="d-flex align-items-center gap-3 mt-1">
              <h4 className="mb-0">Station Rules - {detailsData.code}</h4>
              <button className="deactivate_btn" onClick={handleDeactivateClick}>
                <Poweroff/> Deactivate
              </button>
            </div>
            <p>Configure operational rules for shipment handling and discrepancy logic</p>
          </div>
          <hr />
          <StationRulesDetails
            detailsData={detailsData}
            rules={detailsData.rules ? JSON.parse(detailsData.rules) : {}}
            refetch={refetch}
          />
        </>
      ) : (
        <>
          <div>
            <h4>Station Rules</h4>
            <p>Set timing rules for shipment handling and discrepancy logic</p>
          </div>
          <hr />
          <div className="d-flex justify-content-between align-items-center mb-3">
            <TableFilters filtersConfig={filtersConfig} />
          </div>
          <div className='setting_table w-50'>
            <TableGrid
              columns={columns}
              rows={myData?.Rows}
              checkboxSelection={false}
              totalRecords={myData?.TotalRows || 0}
              loading={isFetching}
              rowKey='station_id'
              onIPPChange={ItemPChange}
              onCPChange={currPChange}
            />
          </div>
        </>
      )}

      <CommonModal
        show={showModal}
        onHide={handleModalClose}
        title={modalType === 'activate' ? 'Activate Station Rules?' : 'Deactivate Station Rules?'}
        className='modal_bgw primary_modal'
        footer={
          <div className='d-flex justify-content-between w-100 m-0'>
            <Button variant="secondary" onClick={handleModalClose}>
              Cancel
            </Button>
            {modalType === 'activate'
              ? <Button variant="primary" onClick={handleActivateConfirm}>Activate Rules</Button>
              : <Button variant="primary" onClick={handleDeactivateConfirm}>Deactivate Rules</Button>
            }
          </div>
        }
      >
        {modalType === 'activate'
          ? <p>Default discrepancy rules will be applied for <strong>{pendingActivateRow?.port_code}</strong>. You can review and adjust the values after activation.</p>
          : <p>Discrepancy rules will no longer be applied for<strong>{detailsData?.code}</strong> Existing discrepancies will remain unchanged.</p>
        }
      </CommonModal>
    </>
  );
};

export default StationRules;